import { Query } from 'react-apollo'
import me, { Me } from '../../graphql/queries/me'
import withQuery from './withQuery'
import { GetProps } from '../../types'

class MeQuery extends Query<Me, {}> {}

const MeQueryCompleted = withQuery(me)(MeQuery)

export type MeQueryProps = GetProps<typeof MeQueryCompleted>
export type MeQueryResult = Me

export default MeQueryCompleted



// WEBPACK FOOTER //
// ./src/components/queries/MeQuery.tsx